import styled from '@emotion/styled';
import TreeItem from '@mui/lab/TreeItem';
import TreeView from '@mui/lab/TreeView';
import React, { useEffect, useState } from 'react';
import { Environment } from '../../shared/environment';
import { AlertSnackBar } from '../../shared/components';
import { LayoutBaseDePagina } from '../../shared/layouts';
import { useAppThemeContext } from '../../shared/contexts';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { CaixaService } from '../../shared/services/api/caixa/CaixaService';
import DocumentViewer from '../../shared/components/visualizador-de-documento/DocumentViewer';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { IndicesCadastro } from '../../shared/components/indices/IndicesCadastro';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { IListagemTipo, RenderTree, TipoService } from '../../shared/services/api/tipo/TipoService';
import { DocumentoService, IIndice_Documento } from '../../shared/services/api/documento/DocumentoService';
import { ITipo_Indice_Documento, Tipo_Indice_Service } from '../../shared/services/api/tipo_indice/Tipo_Indice_Service';
import { ConversorDeValorIndice } from '../../shared/components/indices/ConversorDeValorIndice';
import { Box, Button, Paper, useTheme, Typography, CircularProgress, Icon, Grid, Modal } from '@mui/material';
import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress';


interface IListTipos {
    idTipo: number,
    idTipoPai: number | null,
    nivel: number,
    idSetor: number
    nomeTipo: string,
}

function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary' }}
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

export const CadastrarIndices: React.FC = () => {
    const { idCaixa = "null" } = useParams<'idCaixa'>();

    const theme = useTheme();
    const navigate = useNavigate();

    const [alertSnackbar, setAlertSnackbar] = useState<{ tipoAlert: string, mensagem: string } | undefined>(undefined);
    const [duracaoAlert, setDuracaoAlert] = useState<number>(Environment.DURACAO_ALERT + 500);
    const [selectedNomeTipo, setSelectedNomeTipo] = useState<string>("");
    const [selectedIdTipo, setSelectedIdTipo] = useState<number>(0);
    const [rowsTipo, setRowsTipo] = useState<IListagemTipo[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasNext, setHasNext] = useState<boolean>(false);
    const [valores, setValores] = useState<string[]>([]);
    const [arquivo, setArquivo] = useState<string>("");
    const [mimeType, setMimeType] = useState<string>("");
    const [idsDoc, setIdsDoc] = useState<number[]>([]);
    const [idDoc, setIdDoc] = useState<number>(0);
    const [qtde, setQtde] = useState<number>(0);
    const [reset, setReset] = useState(false);
    const [abrirModal, setAbrirModal] = useState(false);
    const [progressLoading, setProgressLoading] = useState(0);

    useEffect(() => {
        if (((idCaixa === undefined || idCaixa === null || idCaixa === "0"))) {
            navigate(-1);
        }
        setIsLoadingTipo(true);
        CaixaService.getTiposByIdCaixa(Number(idCaixa)).then((result) => {
            setIsLoadingTipo(false);

            if (result instanceof Error) {//verificar se deu erro
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                var dadosSetor: Array<{ idTipo: string, nomeTipo: string, idTipoPai: number | null, nivel: number, idSetor: number, tipos: IListTipos }> = [];
                result.map(setor => {
                    var dados: Array<IListTipos> = [];
                    setor.tipos.map(row => {
                        dados.push(
                            {
                                'idTipo': row.idTipo,
                                'idTipoPai': row.idTipoPai,
                                'nomeTipo': row.nomeTipo,
                                'nivel': row.nivel,
                                'idSetor': row.idSetor,
                            },
                        );
                    })

                    const idMapping = dados.reduce((acc, el, i) => {
                        //@ts-expect-error
                        acc[el.idTipo] = i;
                        return acc;
                    }, {});

                    let raiz: IListTipos[] = [];
                    dados.forEach((el) => {
                        // Pega o elemento que não tem pai
                        if (el.idTipoPai === null) {
                            raiz = [...raiz, el];
                            return;
                        }
                        //@ts-expect-error // Usa o map para locailizar o elemento pai
                        const parentEl = dados[idMapping[el.idTipoPai]];
                        //@ts-expect-error // Adiciona o elemento atual para o `tipos`do pai
                        parentEl.tipos = [...(parentEl.tipos || []), el];
                    });

                    dadosSetor.push(
                        {
                            'idTipo': setor.nomeSetor,
                            'idTipoPai': null,
                            'nomeTipo': setor.nomeSetor,
                            'nivel': 0,
                            'idSetor': setor.idSetor,
                            //@ts-expect-error
                            'tipos': raiz,
                        },
                    );
                });
                //@ts-expect-error
                setRowsTipo(dadosSetor);
            }
        });
    }, []);

    // Requisição para pegar os documentos
    useEffect(() => {
        pesquisarDocumentos();
    }, []);

    const pesquisarDocumentos = () => {
        setIsLoading(true);

        setProgressLoading(0);

        DocumentoService.docuementoNaoIndexado(Number(idCaixa)).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) {//verificar se deu erro
                setIdsDoc([]);
                setAbrirModal(true);
            } else {
                setIdsDoc(result);
                setQtde(0);

                if (result.length > 1) { setHasNext(true); }
                setIdDoc(result[0]);
                carregarDocumento(result[0]);
            }
        });
    }

    const carregarDocumento = (idDoc: number) => {
        setIsLoading(true);
        DocumentoService.pesquisarDoc(idDoc, (progress) => {
            setProgressLoading(progress);
        }).then((result) => {
            setIsLoading(false);
            setProgressLoading(0);

            if (result instanceof Error) {//verificar se deu erro
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {
                setArquivo(window.URL.createObjectURL(result.blob));
                setMimeType(result.headers.get("Content-Type") || "");
                if(qtde < idsDoc.length) 
                {
                    setQtde(qtde + 1);
                }
            }
        });
    }


    const handleSaveAndNext = () => {
        if (valores.every((valor) => valor === "")) {
            setAlertSnackbar({ tipoAlert: "aviso", mensagem: "Preencha no mínimo um campo" });
            setTimeout(() => {
                setAlertSnackbar(undefined);
            }, duracaoAlert);
            return;
        }

        setIsLoading(true);

        var dadosIndice: IIndice_Documento[] = [];

        rowsIndice.map((indice, index) => {
            var valor: string | null = valores[index];
            var dataInicial: string | null = null;
            var dataFinal: string | null = null
            if (indice.idComponente === 5) {
                valor = null;
                dataInicial = valores[index];
            }
            if (indice.idComponente === 6) {
                valor = null;
                dataInicial = valores[index]?.split(" | ")[0];
                dataFinal = valores[index]?.split(" | ")[1];
            }

            if (indice.idComponente === 4 && valor !== '' && valor !== undefined && valor !== null) {// se for checkbox
                var aux = valor.split(", ");// transforma em array
                aux.pop();// retira a ultima posição(virgula com espaço)
                valor = aux.join(", ");// tranforma em string adicionando virgula e espaco entre cada elemento
            }

            dadosIndice.push({
                idDocumento: idDoc,
                idIndice: indice.idIndice,
                valor: valor,
                dataInicial: dataInicial,
                dataFinal: dataFinal,
            });

        });

        DocumentoService.createIndice_Documento(dadosIndice).then((result) => {
            setIsLoading(false);

            if (result instanceof Error) {
                setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
            } else {

                setAlertSnackbar({ tipoAlert: "sucesso", mensagem: "Documento indexado com sucesso!" });
                setTimeout(() => {
                    setAlertSnackbar(undefined);
                }, duracaoAlert);
                handleLimparCampos();
                handleNext();
            }
        });

        handleLimparCampos();
    }

    const handleNext = () => {
        const index = idsDoc.findIndex((id) => id === idDoc);
        if (idsDoc.length > index + 1) {
            setIdDoc(idsDoc[index + 1]);
            carregarDocumento(idsDoc[index + 1]);
            return;
        }
        pesquisarDocumentos();

    }

    const handlePrevious = () => {
        const index = idsDoc.findIndex((id) => id === idDoc);
        if (index > 1) {
            setIdDoc(idsDoc[index - 1]);
            carregarDocumento(idsDoc[index - 1]);
            return;
        }
        pesquisarDocumentos();
    }


    const handleLimparCampos = () => {
        setReset(true);
        setTimeout(() => setReset(false), 0); // Resetar para false imediatamente após para permitir futuros resets
        setArquivo("");
        setInitialValues([]); // evita mostrar por um instante os valores pré-preenchidos do documento anterior
    }

    const handleValoresAlterarChange = (novosValores: string[]) => {
        setValores(novosValores);
    };

    const [rowsIndice, setRowsIndice] = useState<ITipo_Indice_Documento[]>([]);
    const [isLoadingTipo, setIsLoadingTipo] = useState(false);
    const [idTipo, setIdTipo] = useState<number>(0);

    useEffect(() => {
        setRowsIndice([]);
        if (idTipo !== 0) {
            setIsLoading(true);
            Tipo_Indice_Service.getByIdTipo(idTipo, false).then((result) => {
                setIsLoading(false);
                if (result instanceof Error) {
                    setAlertSnackbar({ tipoAlert: "erro", mensagem: result.message });
                    setTimeout(() => {
                        setAlertSnackbar(undefined);
                    }, duracaoAlert);
                } else {
                    setRowsIndice(result);

                    var auxVal: string[] = [];
                    result.map(result => {
                        auxVal.push("");
                    });

                    setValores(auxVal);
                }
            });
        }
    }, [idTipo])

    // Pré-preenche os índices que o documento já tiver (ex.: extraídos por revisão humana/automática antes de chegar aqui).
    const [initialValues, setInitialValues] = useState<string[]>([]);
    const [initialValuesKey, setInitialValuesKey] = useState(0);

    useEffect(() => {
        if (idDoc === 0 || rowsIndice.length === 0) return;

        DocumentoService.getIndice_DocumentoByIdDocumento(idDoc).then((result) => {
            if (result instanceof Error) return; // sem índices preenchidos ainda, ou falha ao consultar: mantém os campos em branco

            const porIdIndice = new Map(result.map((item) => [item.idIndice, item]));
            const valoresPreenchidos = rowsIndice.map((indice) => ConversorDeValorIndice.paraValorUI(porIdIndice.get(indice.idIndice)));

            setInitialValues(valoresPreenchidos);
            setInitialValuesKey((chave) => chave + 1);
        });
    }, [idDoc, rowsIndice])

    const [openDialog, setOpenDialog] = useState(false);

    const handleClickOpen = () => {
        setOpenDialog(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
    };

    const { themeName } = useAppThemeContext();

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(() => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.background.paper,
            color: themeName === "light" ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.8)',
            maxWidth: 220,
            border: '1px solid #dadde9',
        },
    }));

    const handleSelectTipo = (idTipo: number, nomeTipo: string) => {
        setSelectedIdTipo(idTipo);
        setSelectedNomeTipo(nomeTipo);
    };

    const renderTree = (nodes: RenderTree) => (
        <TreeItem key={nodes.idTipo} nodeId={(nodes.idTipo).toString()} label={nodes.nomeTipo} onClick={() => {
            const regex = /^[0-9\b]+$/;// para não entrar os setores que tambem estão na tree view
            if (regex.test((nodes.idTipo).toString())) {
                handleSelectTipo(nodes.idTipo, nodes.nomeTipo)
            }
        }}>
            {Array.isArray(nodes.tipos)
                ? nodes.tipos.map((node) => renderTree(node))
                : null}
        </TreeItem>
    );

    const handleConfirmar = () => {
        setIdTipo(selectedIdTipo);
        handleClose();
    };

    return (
        <LayoutBaseDePagina titulo="Cadastrar índices" barraDeFerramentas={
            <>
                <Box
                    component={Paper}
                    height={theme.spacing(5)}
                    marginX={1}
                    padding={1}
                    paddingX={2}
                    display="flex"
                    gap={1}
                    marginBottom={theme.spacing(1)}
                    alignItems="center"
                >
                    {alertSnackbar !== undefined && (
                        <>
                            {alertSnackbar.tipoAlert === "sucesso" && (
                                <AlertSnackBar gravidade="success" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                            {alertSnackbar.tipoAlert === "erro" && (
                                <AlertSnackBar gravidade="error" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                            {alertSnackbar.tipoAlert === "aviso" && (
                                <AlertSnackBar gravidade="warning" mensagem={alertSnackbar.mensagem} returnedDuration={duracao => setDuracaoAlert(duracao + 500)} />
                            )}
                        </>
                    )}

                    <Button
                        color={themeName == 'light' ? 'secondary' : 'primary'}
                        disableElevation
                        variant="outlined"
                        startIcon={<Icon color={themeName == 'light' ? 'secondary' : 'primary'}>arrow_back</Icon>}
                        onClick={() => { navigate(-1) }}
                    >
                        <Typography
                            variant='button'
                            noWrap
                            color={themeName == 'light' ? 'secondary' : 'primary'}
                        >
                            Sair
                        </Typography>
                    </Button>
                    <Button
                        color="primary"
                        disableElevation
                        variant="contained"
                        startIcon={<Icon>arrow_back</Icon>}
                        onClick={() => { handlePrevious() }}
                        disabled={idsDoc.length == 0 || idDoc == idsDoc[0] || isLoading}
                    >
                        <Typography variant='button' noWrap>
                            Anterior
                        </Typography>
                    </Button>

                    <Box flex={7} display="flex" justifyContent="center" width="100%">
                        <Typography variant='h6' noWrap>
                            <>
                                Documento {idsDoc.length && qtde + " de " + idsDoc.length}
                            </>
                        </Typography>
                    </Box>

                    <Box flex={1} display="flex" justifyContent="end">
                        <Button
                            color="primary"
                            disableElevation
                            variant="contained"
                            endIcon={<Icon>arrow_forward</Icon>}
                            onClick={() => handleNext()}
                            disabled={!hasNext || isLoading || !!!selectedIdTipo}
                        >
                            <Typography variant='button' noWrap>
                                Próximo
                            </Typography>
                        </Button>
                    </Box>

                    <Box flex={1} display="flex" justifyContent="end">
                        <Button
                            color="primary"
                            disableElevation
                            variant="contained"
                            endIcon={<Icon>save</Icon>}
                            onClick={() => handleSaveAndNext()}
                            disabled={/*!hasNext || */isLoading || !!!selectedIdTipo}
                        >
                            <Typography variant='button' noWrap>
                                Salvar e Próximo
                            </Typography>
                        </Button>
                    </Box>

                </Box>
            </>
        }>

            <Modal
                open={abrirModal}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100vh',
                        outline: 'none', // Remove the default outline for better styling
                    }}>
                    <Box
                        sx={{
                            backgroundColor: 'background.paper',
                            boxShadow: 24,
                            p: 4,
                            borderRadius: 1,
                            textAlign: 'center',
                        }}>
                        <Typography variant="h5" align="center"> {idsDoc.length > 0 ? "Nem todos" : "Todos"} os documentos foram indexados! </Typography>
                        <hr />
                        <Box

                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            marginTop={2}
                            gap={1}
                        >
                            <Button
                                color="primary"
                                disableElevation
                                variant="outlined"
                                startIcon={<Icon>arrow_back</Icon>}
                                onClick={() => navigate('/caixa/')}
                            >
                                <Typography variant='button' noWrap> Sair </Typography>
                            </Button>

                            {idsDoc.length > 0 &&
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setAbrirModal(false)}
                                >
                                    {idsDoc.length > 1 ?
                                        <Typography variant='button' noWrap> restam {idsDoc.length} documentos </Typography>
                                        :
                                        <Typography variant='button' noWrap> resta {idsDoc.length} documento </Typography>
                                    }
                                </Button>
                            }
                        </Box>

                    </Box>
                </Box>
            </Modal>

            <Dialog
                open={openDialog}
                onClose={handleClose}
            >
                <DialogTitle id="scroll-dialog-title"> Tipos </DialogTitle>
                <DialogContent dividers>
                    {isLoadingTipo ? (
                        <Box display="flex" justifyContent="center" alignItems="center">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <TreeView
                            defaultCollapseIcon={<ExpandMoreIcon />}
                            defaultExpandIcon={<ChevronRightIcon />}
                            selected={selectedIdTipo.toString()}
                            sx={{ width: 500, minHeight: 200, flexGrow: 1 }}
                        >
                            {rowsTipo.map(tipo => renderTree(tipo))}
                        </TreeView>
                    )}

                    <HtmlTooltip arrow title={
                        <React.Fragment>
                            Para que um tipo seja listado aqui, é necessário que tenha no mínimo 1 (um) índice de DOCUMENTO
                        </React.Fragment>
                    }>

                        <Typography variant='caption' > <u> Não encontrou algum tipo? </u> </Typography>

                    </HtmlTooltip>

                </DialogContent>
                <DialogActions>
                    <Box
                        width="100%"
                        marginX={1}
                        padding={1}
                        paddingX={2}
                        gap={1}
                        display="flex"
                        justifyContent="center"
                    >
                        <Button variant="contained" color="error" startIcon={<Icon>close</Icon>} onClick={handleClose}>
                            <Typography variant='button' noWrap> Fechar </Typography>
                        </Button>
                        <Button variant="contained" startIcon={<Icon>check</Icon>} onClick={handleConfirmar}>
                            <Typography variant='button' noWrap> Confirmar </Typography>
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>

            <Box
                component={Paper}
                padding={2}
                marginX={1}
            >
                <Grid container item direction="column" spacing={2}>
                    <Grid container item direction="row" spacing={2}>
                        <Grid item>
                            <Box display="flex" gap={1} alignItems="center">
                                <Button variant="contained" onClick={handleClickOpen}>
                                    <Typography variant='button' noWrap> Mostrar tipos </Typography>
                                </Button>
                                {selectedNomeTipo &&
                                    <Typography> Este documento será do tipo: <b>{selectedNomeTipo}</b> </Typography>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>

                {rowsIndice.length !== 0 && <Typography sx={{ m: 2 }} variant="h4"> Índices </Typography>}

                <IndicesCadastro
                    aoSalvar={() => handleSaveAndNext}
                    rowsAlterarValorIndice={rowsIndice}
                    onValoresAlterarChange={handleValoresAlterarChange}
                    reset={reset}
                    initialValues={initialValues}
                    initialValuesKey={initialValuesKey}
                />

                {isLoading ?
                    (
                        <Grid item xs={12}>
                            {progressLoading !== 0 ?
                                (
                                    <LinearProgressWithLabel value={progressLoading} />
                                )
                                :
                                (
                                    <LinearProgress variant='indeterminate' />
                                )
                            }
                        </Grid>
                    )
                    :
                    selectedIdTipo ?
                        (
                            <Box textAlign="center">
                                <DocumentViewer arquivo={arquivo} mimeType={mimeType}/>
                            </Box>
                        ) :
                        (
                            <Box textAlign="center">
                                <Typography variant="h6"> Selecione um tipo para visualizar o documento </Typography>
                            </Box>
                        )
                }

            </Box>
        </LayoutBaseDePagina>
    );
};
